import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export function iconRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (Validators.required(control)) {
            return { iconRequired: true };
        }
        return null;
    };
}
